import React from 'react';
import classNames from 'classnames';
// import useListOauthProviders from '../../hooks/useListOauthProviders';
import { getOauthRedirectUrl } from '../../hooks/useListOauthProviders';
import NotificationCard from '../ibok-core/module/NotificationCard';
import { buildOauthProviderUrl } from '../../utils/api/oauthApi';
var OauthProviderList = function () {
    // const { providers, error } = useListOauthProviders();
    // Mohand godtok hardcoding av disse...
    var error = null;
    var redirectUrl = getOauthRedirectUrl();
    var providers = [
        { key: 'facebook', label: 'Facebook', url: buildOauthProviderUrl('facebook', redirectUrl) },
        { key: 'google', label: 'Google', url: buildOauthProviderUrl('google', redirectUrl) },
        { key: 'feide', label: 'Feide', url: buildOauthProviderUrl('feide', redirectUrl) },
    ];
    return React.createElement("ul", { className: "providers" },
        error && React.createElement(NotificationCard, { type: "error", title: "Kunne ikke hente innloggingsknapper for tredjepartstjenester" }, "Dette kan v\u00E6re et midlertidig problem. Fors\u00F8k gjerne \u00E5 last om denne siden. Ta gjerne kontakt med brukerst\u00F8tte om problemet skulle vedvare."),
        providers.map(function (provider) { return React.createElement("li", { key: "oauth-" + provider.key },
            React.createElement("a", { className: classNames('button', 'oauth', provider.key), href: provider.url }, provider.label)); }));
};
export default OauthProviderList;
